import { resolveBorder, resolveInputFontSize, resolveLabelFontSize } from '../TextInput/TextInputStyles';
export const resolveSize = (size, theme) => {
  switch (size) {
    case 'small':
    case 'sm':
      return {
        height: '32px',
        fontSize: resolveLabelFontSize(theme, size),
        lineHeight: '14px',
        padding: '8px'
      };
    case 'medium':
    case 'md':
      return {
        height: '40px',
        fontSize: resolveLabelFontSize(theme, size),
        lineHeight: '16px',
        padding: '12px'
      };
    case 'large':
    case 'lg':
      return {
        height: '48px',
        fontSize: resolveLabelFontSize(theme, size),
        lineHeight: '20px',
        padding: '16px'
      };
    default:
      return {
        height: '40px',
        fontSize: resolveLabelFontSize(theme, size),
        lineHeight: '16px',
        padding: '12px'
      };
  }
};
export const boxStyleBuilder = (theme, readOnly, disabled, validationStateType, open, size, selected) => ({
  display: 'flex',
  boxSizing: 'border-box',
  width: '100%',
  padding: resolveSize(size, theme).padding,
  borderRadius: theme.tokens.SemSizeBorderRadiusDefault,
  position: 'relative',
  height: resolveSize(size, theme).height,
  lineHeight: resolveSize(size, theme).lineHeight,
  backgroundColor: readOnly || disabled ? theme.tokens.ComponentTextInputDisabledBgColor : theme.tokens.ComponentTextInputBg,
  fontSize: resolveSize(size, theme).fontSize,
  fontFamily: theme.tokens.ComponentTextInputFontFamily,
  fontWeight: theme.tokens.ComponentTextInputFontWeight,
  boxShadow: open && validationStateType !== 'error' ? theme.tokens.SemRingFocus : null,
  userSelect: readOnly || disabled ? 'none' : null,
  border: resolveBorder(validationStateType, disabled, readOnly, theme, open) || `1px solid ${theme.tokens.ComponentTextInputBorderColor}`,
  color: readOnly || disabled ? theme.tokens.ComponentTextInputDisabledColor : !selected ? theme.tokens.ComponentSelectInputDisabledColor : theme.tokens.ComponentSelectInputReadOnlyColor,
  cursor: readOnly || disabled ? 'not-allowed' : 'pointer',
  transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
  '&:focus-visible': {
    border: `1px solid ${theme.tokens.ComponentTextInputBorderFocusColor}`,
    boxShadow: theme.tokens.SemRingFocus,
    outline: 'none'
  },
  '.interstate-select-value': {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    height: 'fit-content',
    fontSize: resolveInputFontSize(theme, size)
  }
});
export const chevronColorSelector = (type, disabled, theme) => {
  if (disabled) {
    return `${theme.tokens.SemColorOnSurfaceSubtle}`;
  } else if (type === 'error') {
    return `${theme.tokens.ComponentSelectInputChevronIconErrorColor}`;
  } else {
    return `${theme.tokens.ComponentSelectInputChevronIconActiveColor}`;
  }
};
export const chevronSizeSelector = (size, theme) => {
  switch (size) {
    case 'small':
    case 'sm':
      return 14;
    case 'medium':
    case 'md':
      return 16;
    case 'large':
    case 'lg':
      return 20;
    default:
      return 16;
  }
};